export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.workbench.link': '工作台',
  'pages.workbench.alertMessage': '欢迎来到工作台',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.customerIntelligence.customerList.columns.name': '客户名称',
  'pages.customerIntelligence.customerList.columns.owner': '负责人',
  'pages.customerIntelligence.customerList.columns.mobile': '手机号',
  'pages.customerIntelligence.customerList.columns.email': '邮箱',
  'pages.customerIntelligence.customerList.columns.followUpStatus': '跟进状态',
  'pages.customerIntelligence.customerList.columns.lockStatus': '锁定状态',
  'pages.customerIntelligence.customerList.columns.dealStatus': '成交状态',
  'pages.customerIntelligence.customerList.columns.contactLastTime':
    '最近联系时间',
  'pages.customerIntelligence.customerList.columns.contactNextTime':
    '下次联系时间',
  'pages.customerIntelligence.customerList.search.keyword': '关键字',
  'pages.customerIntelligence.customerList.placeholder.empty': '-',
  'pages.customerIntelligence.customerList.empty': '暂无客户数据',
  'pages.customerIntelligence.customerList.boolean.yes': '是',
  'pages.customerIntelligence.customerList.boolean.no': '否',
  'pages.customerIntelligence.customerList.create.button': '新增客户',
  'pages.customerIntelligence.customerList.create.modalTitle': '新增客户',
  'pages.customerIntelligence.customerList.create.success': '客户已新增',
  'pages.customerIntelligence.customerList.create.form.name': '客户名称',
  'pages.customerIntelligence.customerList.create.form.name.required':
    '请输入客户名称',
  'pages.customerIntelligence.customerList.create.form.name.placeholder':
    '请输入客户名称',
  'pages.customerIntelligence.customerList.create.form.mobile': '手机号',
  'pages.customerIntelligence.customerList.create.form.telephone': '电话',
  'pages.customerIntelligence.customerList.create.form.email': '邮箱',
  'pages.customerIntelligence.customerList.create.form.qq': 'QQ',
  'pages.customerIntelligence.customerList.create.form.wechat': '微信',
  'pages.customerIntelligence.customerList.create.form.remark': '备注',
  'pages.customerIntelligence.customerList.alert.missingTenant':
    '当前租户上下文缺失，结果可能不完整',
  'pages.customerIntelligence.customerList.alert.missingMember':
    '当前会话缺少 memberUuid，无法查询“我的客户”',
  'pages.zyConsultantOperations.diagnosisSessions.columns.customerName':
    '客户名称',
  'pages.zyConsultantOperations.diagnosisSessions.columns.title': '标题',
  'pages.zyConsultantOperations.diagnosisSessions.columns.diagnosisDate':
    '诊断日期',
  'pages.zyConsultantOperations.diagnosisSessions.columns.industry': '行业',
  'pages.zyConsultantOperations.diagnosisSessions.columns.intervieweeRole':
    '访谈对象',
  'pages.zyConsultantOperations.diagnosisSessions.columns.status': '状态',
  'pages.zyConsultantOperations.diagnosisSessions.columns.overallRiskLevel':
    '总体风险',
  'pages.zyConsultantOperations.diagnosisSessions.columns.actions': '操作',
  'pages.zyConsultantOperations.diagnosisSessions.actions.detail': '详情',
  'pages.zyConsultantOperations.diagnosisSessions.actions.run': '执行',
  'pages.zyConsultantOperations.diagnosisSessions.actions.result': '结果',
  'pages.zyConsultantOperations.diagnosisSessions.search.placeholder':
    '搜索标题/客户/行业',
  'pages.zyConsultantOperations.diagnosisSessions.search.statusPlaceholder':
    '状态',
  'pages.zyConsultantOperations.diagnosisSessions.create.button':
    '新建诊断调查',
  'pages.zyConsultantOperations.diagnosisSessions.create.modalTitle':
    '新建诊断调查',
  'pages.zyConsultantOperations.diagnosisSessions.create.success':
    '诊断调查已创建',
  'pages.zyConsultantOperations.diagnosisSessions.form.pack': '题包',
  'pages.zyConsultantOperations.diagnosisSessions.form.customer': '客户',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerPlaceholder':
    '搜索并选择我的客户',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerLoadFailed':
    '加载客户列表失败',
  'pages.zyConsultantOperations.diagnosisSessions.form.missingMember':
    '当前会话缺少 memberUuid，无法加载“我的客户”',
  'pages.zyConsultantOperations.diagnosisSessions.form.titleSuggestionFailed':
    '生成标题建议失败',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerName':
    '客户名称',
  'pages.zyConsultantOperations.diagnosisSessions.form.title': '标题',
  'pages.zyConsultantOperations.diagnosisSessions.form.titlePlaceholder':
    '将按客户自动生成标题，仍可手动修改',
  'pages.zyConsultantOperations.diagnosisSessions.form.diagnosisDate':
    '诊断日期',
  'pages.zyConsultantOperations.diagnosisSessions.form.industry': '行业',
  'pages.zyConsultantOperations.diagnosisSessions.form.intervieweeRole':
    '访谈对象',
  'pages.zyConsultantOperations.diagnosisSessions.form.sourceChannel':
    '来源渠道',
  'pages.zyConsultantOperations.diagnosisSessions.form.required': '此项为必填',
  'pages.zyConsultantOperations.diagnosisSessions.status.draft': '草稿',
  'pages.zyConsultantOperations.diagnosisSessions.status.inProgress': '进行中',
  'pages.zyConsultantOperations.diagnosisSessions.status.completed': '已完成',
  'pages.zyConsultantOperations.diagnosisRun.loading': '加载中...',
  'pages.zyConsultantOperations.diagnosisRun.titlePrefix': '执行诊断',
  'pages.zyConsultantOperations.diagnosisRun.boolean.yes': '是',
  'pages.zyConsultantOperations.diagnosisRun.boolean.no': '否',
  'pages.zyConsultantOperations.diagnosisRun.field.evidenceSummary': '证据摘要',
  'pages.zyConsultantOperations.diagnosisRun.field.note': '顾问备注',
  'pages.zyConsultantOperations.diagnosisRun.action.save': '保存答案',
  'pages.zyConsultantOperations.diagnosisRun.action.finish': '完成诊断',
  'pages.zyConsultantOperations.diagnosisRun.message.answersSaved':
    '答案已保存',
  'pages.zyConsultantOperations.diagnosisRun.message.finished': '诊断已完成',
  'pages.zyConsultantOperations.diagnosisResult.loading': '加载中...',
  'pages.zyConsultantOperations.diagnosisResult.cardTitle': '诊断结果',
  'pages.zyConsultantOperations.diagnosisResult.card.overallRisk': '总体风险',
  'pages.zyConsultantOperations.diagnosisResult.card.highRisk': '高风险',
  'pages.zyConsultantOperations.diagnosisResult.card.mediumRisk': '中风险',
  'pages.zyConsultantOperations.diagnosisResult.card.lowRisk': '低风险',
  'pages.zyConsultantOperations.diagnosisResult.section.dimensionScores':
    '维度得分',
  'pages.zyConsultantOperations.diagnosisResult.section.highlightedQuestions':
    '重点问题',
  'pages.zyConsultantOperations.diagnosisResult.section.suggestionDirections':
    '建议方向',
  'pages.zyConsultantOperations.diagnosisResult.column.frameworkType': '框架',
  'pages.zyConsultantOperations.diagnosisResult.column.level1': '一级维度',
  'pages.zyConsultantOperations.diagnosisResult.column.level2': '二级维度',
  'pages.zyConsultantOperations.diagnosisResult.column.averageScore': '平均分',
  'pages.zyConsultantOperations.diagnosisResult.column.answeredCount':
    '已答题数',
  'pages.zyConsultantOperations.diagnosisResult.column.questionTitle': '问题',
  'pages.zyConsultantOperations.diagnosisResult.column.riskLevel': '风险',
  'pages.zyConsultantOperations.diagnosisResult.column.causeType': '归因',
  'pages.zyConsultantOperations.diagnosisResult.column.solutionDirection':
    '方案方向',
  'pages.zyConsultantOperations.diagnosisResult.column.answer': '答案',
  'pages.zyConsultantOperations.diagnosisDetail.loading': '加载中...',
  'pages.zyConsultantOperations.diagnosisDetail.invalidUuid':
    '缺少诊断调查 uuid 参数',
  'pages.zyConsultantOperations.diagnosisDetail.titleFallback': '诊断调查',
  'pages.zyConsultantOperations.diagnosisDetail.tab.basic': '基本信息',
  'pages.zyConsultantOperations.diagnosisDetail.tab.questions': '题包题目',
  'pages.zyConsultantOperations.diagnosisDetail.tab.analysis': '统计分析',
  'pages.zyConsultantOperations.diagnosisDetail.field.createdAt': '创建时间',
  'pages.zyConsultantOperations.diagnosisDetail.field.startedAt': '开始时间',
  'pages.zyConsultantOperations.diagnosisDetail.field.completedAt': '完成时间',
  'pages.zyConsultantOperations.diagnosisDetail.message.started':
    '诊断调查已开始',
  'pages.zyConsultantOperations.diagnosisDetail.questions.notStarted':
    '当前调查还未开始',
  'pages.zyConsultantOperations.diagnosisDetail.questions.start': '开始并作答',
  'pages.zyConsultantOperations.diagnosisDetail.questions.empty':
    '当前调查没有题目',
  'pages.zyConsultantOperations.diagnosisDetail.analysis.empty':
    '暂无统计分析数据，请先完成题目作答并保存',
  'pages.zyConsultantOperations.settings.tab.codeRules': '编码规则',
  'pages.zyConsultantOperations.settings.tab.dict': '字典管理',
  'pages.zyConsultantOperations.settings.tab.taxonomy': '标签管理',
  'pages.zyConsultantOperations.settings.dict.types': '字典类型',
  'pages.zyConsultantOperations.settings.dict.items': '字典项',
  'pages.zyConsultantOperations.settings.dict.questionCategory': '问题分类',
  'pages.zyConsultantOperations.settings.taxonomy.list': '分类法列表',
  'pages.zyConsultantOperations.settings.taxonomy.tree': '标签树',
  'pages.zyConsultantOperations.settings.taxonomy.aiWorkbench': 'AI 新增标签',
  'pages.zyConsultantOperations.settings.taxonomy.generateOptions': '生成选项',
  'pages.zyConsultantOperations.settings.taxonomy.preview': '预览结果',
  'pages.zyConsultantOperations.settings.taxonomy.previewHint':
    '勾选需要的标签后添加到标签树',
  'pages.zyConsultantOperations.settings.taxonomy.target': '当前落点',
  'pages.zyConsultantOperations.settings.taxonomy.targetChild':
    '作为子标签新增',
  'pages.zyConsultantOperations.settings.taxonomy.targetRoot': '作为根标签新增',
  'pages.zyConsultantOperations.settings.taxonomy.rootTarget': '当前分类法根级',
  'pages.zyConsultantOperations.settings.taxonomy.targetHint':
    '先在左侧标签树点选一个标签，可把候选统一挂到该标签下。',
  'pages.zyConsultantOperations.settings.taxonomy.mode': '拆解方式',
  'pages.zyConsultantOperations.settings.taxonomy.modeSmart':
    '智能拆解尽可能多',
  'pages.zyConsultantOperations.settings.taxonomy.modeCount': '拆解指定数量',
  'pages.zyConsultantOperations.settings.taxonomy.modeManual':
    '人工录入（每行一个）',
  'pages.zyConsultantOperations.settings.taxonomy.subject': '拆解主题',
  'pages.zyConsultantOperations.settings.taxonomy.subjectPlaceholder':
    '例如：组织协同、数据治理、经营分析',
  'pages.zyConsultantOperations.settings.taxonomy.subjectPlaceholderSelected':
    '默认围绕已选标签继续细化，也可以补充更具体的主题',
  'pages.zyConsultantOperations.settings.taxonomy.targetCount': '目标数量',
  'pages.zyConsultantOperations.settings.taxonomy.manualInput': '人工录入',
  'pages.zyConsultantOperations.settings.taxonomy.manualInputPlaceholder':
    '每行一个标签草稿，例如：\n流程协同\n数据口径统一\n经营复盘机制',
  'pages.zyConsultantOperations.settings.taxonomy.prompt': '拆解提示',
  'pages.zyConsultantOperations.settings.taxonomy.promptPlaceholder':
    '例如：更偏咨询诊断语言、避免重复已有标签、优先组织与流程维度',
  'pages.zyConsultantOperations.settings.taxonomy.aiMeta': '本次拆解由模型生成',
  'pages.zyConsultantOperations.settings.taxonomy.reason': '拆解依据',
  'pages.zyConsultantOperations.settings.taxonomy.emptyCandidates':
    '先选择拆解方式并生成候选，再批量创建到标签树。',
  'pages.zyConsultantOperations.settings.column.code': '编码',
  'pages.zyConsultantOperations.settings.column.name': '名称',
  'pages.zyConsultantOperations.settings.column.description': '描述',
  'pages.zyConsultantOperations.settings.column.value': '值',
  'pages.zyConsultantOperations.settings.column.sortOrder': '排序',
  'pages.zyConsultantOperations.settings.column.enabled': '启用',
  'pages.zyConsultantOperations.settings.column.actions': '操作',
  'pages.zyConsultantOperations.settings.action.edit': '编辑',
  'pages.zyConsultantOperations.settings.action.delete': '删除',
  'pages.zyConsultantOperations.settings.action.refresh': '刷新',
  'pages.zyConsultantOperations.settings.action.moveTop': '移到最前',
  'pages.zyConsultantOperations.settings.action.moveUp': '上移',
  'pages.zyConsultantOperations.settings.action.moveDown': '下移',
  'pages.zyConsultantOperations.settings.action.moveBottom': '移到最后',
  'pages.zyConsultantOperations.settings.action.addCategory': '新增分类',
  'pages.zyConsultantOperations.settings.action.addChildCategory': '新增子类',
  'pages.zyConsultantOperations.settings.action.addDictItem': '新增字典项',
  'pages.zyConsultantOperations.settings.action.addDictType': '新增类型',
  'pages.zyConsultantOperations.settings.action.addTaxonomy': '新增分类法',
  'pages.zyConsultantOperations.settings.action.initEnterprisePortraitTaxonomies':
    '初始化企业画像',
  'pages.zyConsultantOperations.settings.action.addSiblingTag': '新增同级标签',
  'pages.zyConsultantOperations.settings.action.addRootTag': '新增根标签',
  'pages.zyConsultantOperations.settings.action.addChildTag': '新增子标签',
  'pages.zyConsultantOperations.settings.action.openAiModal': 'AI 新增标签',
  'pages.zyConsultantOperations.settings.action.clearTarget': '定位到根级',
  'pages.zyConsultantOperations.settings.action.clearCandidates': '清空候选',
  'pages.zyConsultantOperations.settings.action.createSelectedCandidates':
    '创建勾选候选',
  'pages.zyConsultantOperations.settings.action.generateCandidates':
    '生成候选标签',
  'pages.zyConsultantOperations.settings.action.resetPrompt': '清空输入',
  'pages.zyConsultantOperations.settings.action.cancel': '取消',
  'pages.zyConsultantOperations.settings.modal.editDictItem': '编辑字典项',
  'pages.zyConsultantOperations.settings.modal.addDictType': '新增字典类型',
  'pages.zyConsultantOperations.settings.modal.addDictItem': '新增字典项',
  'pages.zyConsultantOperations.settings.message.dictItemUpdated':
    '字典项已更新',
  'pages.zyConsultantOperations.settings.message.dictItemCreated':
    '字典项已创建',
  'pages.zyConsultantOperations.settings.message.dictItemDeleted':
    '字典项已删除',
  'pages.zyConsultantOperations.settings.message.categoryUpdated': '分类已更新',
  'pages.zyConsultantOperations.settings.message.categoryCreated': '分类已创建',
  'pages.zyConsultantOperations.settings.message.taxonomyUpdated':
    '分类法已更新',
  'pages.zyConsultantOperations.settings.message.taxonomyCreated':
    '分类法已创建',
  'pages.zyConsultantOperations.settings.message.taxonomyDeleted':
    '分类法已删除',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesInitialized':
    '企业画像分类法已初始化',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesCreated':
    '新增分类法',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTagsCreated':
    '新增标签',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesSkipped':
    '跳过分类法',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTagsSkipped':
    '跳过标签',
  'pages.zyConsultantOperations.settings.message.tagUpdated': '标签已更新',
  'pages.zyConsultantOperations.settings.message.tagCreated': '标签已创建',
  'pages.zyConsultantOperations.settings.message.tagDeleted': '标签已删除',
  'pages.zyConsultantOperations.settings.message.selectTaxonomyFirst':
    '请先选择一个分类法',
  'pages.zyConsultantOperations.settings.message.aiCandidatesReady':
    '已生成候选标签',
  'pages.zyConsultantOperations.settings.message.selectCandidateFirst':
    '请至少勾选一条候选标签',
  'pages.zyConsultantOperations.settings.message.aiCreatePartial':
    '候选标签创建完成',
  'pages.zyConsultantOperations.settings.message.aiCreateSuccess':
    '候选标签已批量创建',
  'pages.fieldResearch.records.title': '现场调研执行记录',
  'pages.fieldResearch.records.search.placeholder': '搜索客户或标题',
  'pages.fieldResearch.records.search.status': '状态',
  'pages.fieldResearch.records.create': '新建执行记录',
  'pages.fieldResearch.records.columns.title': '标题',
  'pages.fieldResearch.records.columns.customer': '客户',
  'pages.fieldResearch.records.columns.researchDate': '调研日期',
  'pages.fieldResearch.records.columns.status': '状态',
  'pages.fieldResearch.records.columns.updatedAt': '更新时间',
  'pages.fieldResearch.records.columns.actions': '操作',
  'pages.fieldResearch.records.actions.continue': '继续执行',
  'pages.fieldResearch.records.actions.view': '查看面板',
  'pages.fieldResearch.records.form.customer': '客户',
  'pages.fieldResearch.records.form.customerPlaceholder': '请选择客户',
  'pages.fieldResearch.records.form.title': '标题',
  'pages.fieldResearch.records.form.titlePlaceholder': '可选，默认自动生成',
  'pages.fieldResearch.records.form.researchDate': '调研日期',
  'pages.fieldResearch.records.status.draft': '草稿',
  'pages.fieldResearch.records.status.inProgress': '进行中',
  'pages.fieldResearch.records.status.completed': '已完成',
  'pages.fieldResearch.records.status.archived': '已归档',
  'pages.fieldResearch.panel.loading': '执行面板加载中...',
  'pages.fieldResearch.panel.left.customer': '客户信息',
  'pages.fieldResearch.panel.left.questions': '问题搜索',
  'pages.fieldResearch.panel.left.tasks': '任务',
  'pages.fieldResearch.panel.left.tab.question': '直接搜问题',
  'pages.fieldResearch.panel.left.tab.tag': '先搜标签',
  'pages.fieldResearch.panel.left.searchPlaceholder': '搜索问题标题/提问语',
  'pages.fieldResearch.panel.left.tagSearchPlaceholder':
    '先搜索标签，再查看相关问题',
  'pages.fieldResearch.panel.left.tagRelatedQuestions': '相关问题',
  'pages.fieldResearch.panel.left.tagSelectHint': '请选择一个标签查看相关问题',
  'pages.fieldResearch.panel.left.tagEmpty': '没有匹配的标签',
  'pages.fieldResearch.panel.left.tagQuestionEmpty': '该标签下暂无问题',
  'pages.fieldResearch.panel.left.detail': '查看详情',
  'pages.fieldResearch.panel.left.addToInterview': '添加到访谈',
  'pages.fieldResearch.panel.middle.records': '访谈记录',
  'pages.fieldResearch.panel.middle.addFree': '新增自由记录',
  'pages.fieldResearch.panel.middle.save': '手动保存',
  'pages.fieldResearch.panel.middle.autoSaved': '已自动保存',
  'pages.fieldResearch.panel.middle.localDraft': '网络异常，已本地暂存',
  'pages.fieldResearch.panel.right.ai': 'AI 对话',
  'pages.fieldResearch.panel.right.related': '关联信息',
  'pages.fieldResearch.panel.right.relatedSearchPlaceholder':
    '搜索当前区域内容',
  'pages.fieldResearch.panel.right.relatedPin': '固定',
  'pages.fieldResearch.panel.right.relatedPinned': '已固定',
  'pages.fieldResearch.panel.right.askPlaceholder':
    '请输入现场问题，AI 会给出建议与依据',
  'pages.fieldResearch.panel.right.send': '发送',
  'pages.fieldResearch.panel.action.complete': '完成执行',
  'pages.fieldResearch.panel.entry.type.question': '问题记录',
  'pages.fieldResearch.panel.entry.type.free': '自由记录',
  'pages.fieldResearch.panel.entry.content': '记录内容',
  'pages.fieldResearch.panel.entry.evidence': '证据备注',
  'pages.fieldResearch.panel.entry.signals': '关键信号（逗号分隔）',
  'pages.fieldResearch.panel.entry.remove': '删除',
  'pages.fieldResearch.panel.entry.title': '记录标题',
  'pages.fieldResearch.panel.entry.save': '保存',
};
